/**
 * Avatar cache utilities
 * Provides cache-busting functionality for avatar images
 */

/**
 * Add cache-busting parameter to avatar URL
 * This forces the browser to fetch fresh avatar images instead of using cache
 * 
 * @param {string} avatarUrl - The avatar URL to add cache-busting to
 * @param {number} timestamp - Optional timestamp (defaults to current time)
 * @returns {string} Avatar URL with cache-busting parameter
 */
export const getCachebustedAvatarUrl = (avatarUrl, timestamp = Date.now()) => {
  if (!avatarUrl) return null;
  
  try {
    const url = new URL(avatarUrl, window.location.origin);
    url.searchParams.set('v', timestamp.toString());
    return url.toString();
  } catch (error) {
    // If URL parsing fails, return original URL
    return `${avatarUrl}?v=${timestamp}`;
  }
};
